import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LandingPage from "@/pages/LandingPage";
import PositionApplicationPage from "@/pages/PositionApplicationPage";
import AuthPage from "@/pages/AuthPage";
import { ForgotPasswordPage, ResetPasswordPage } from "@/pages/PasswordPages";
import { DonatePage, DonateSuccessPage } from "@/pages/DonatePage";
import UcpPage from "@/pages/UcpPage";
import ForumLayout from "@/forum/ForumLayout";
import ForumHome from "@/forum/pages/ForumHome";
import CategoryPage from "@/forum/pages/CategoryPage";
import ThreadPage from "@/forum/pages/ThreadPage";
import NewThreadPage from "@/forum/pages/NewThreadPage";
import SearchPage from "@/forum/pages/SearchPage";
import ProfilePage from "@/forum/pages/ProfilePage";
import MessagesPage from "@/forum/pages/MessagesPage";
import NotificationsPage from "@/forum/pages/NotificationsPage";
import SettingsPage from "@/forum/pages/SettingsPage";
import AdminPage from "@/forum/pages/AdminPage";
import { Spinner } from "@/forum/ui";

const Protected = ({ children, minLevel = -1 }) => {
  const { user, level } = useAuth();
  const loc = useLocation();
  if (user === null) return <Spinner />;
  if (user === false) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (level < minLevel) return <Navigate to="/forum" replace />;
  return children;
};

const Guest = ({ children }) => {
  const { user } = useAuth();
  if (user) return <Navigate to="/forum" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="grain" aria-hidden />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/palyazatok" element={<PositionApplicationPage />} />
          <Route path="/login" element={<Guest><AuthPage mode="login" /></Guest>} />
          <Route path="/register" element={<Guest><AuthPage mode="register" /></Guest>} />
          <Route path="/forgot-password" element={<Guest><ForgotPasswordPage /></Guest>} />
          <Route path="/reset-password" element={<Guest><ResetPasswordPage /></Guest>} />
          <Route path="/tamogatas" element={<DonatePage />} />
          <Route path="/tamogatas/siker" element={<DonateSuccessPage />} />
          <Route path="/ucp" element={<Protected><UcpPage /></Protected>} />
          <Route path="/forum" element={<ForumLayout />}>
            <Route index element={<ForumHome />} />
            <Route path="c/:slug" element={<CategoryPage />} />
            <Route path="t/:id" element={<ThreadPage />} />
            <Route path="new/:slug" element={<Protected minLevel={0}><NewThreadPage /></Protected>} />
            <Route path="search" element={<SearchPage />} />
            <Route path="u/:username" element={<ProfilePage />} />
            <Route path="messages" element={<Protected><MessagesPage /></Protected>} />
            <Route path="messages/:username" element={<Protected><MessagesPage /></Protected>} />
            <Route path="notifications" element={<Protected><NotificationsPage /></Protected>} />
            <Route path="settings" element={<Protected><SettingsPage /></Protected>} />
            <Route path="admin" element={<Protected minLevel={2}><AdminPage /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster
          position="bottom-center"
          theme="dark"
          toastOptions={{ style: { background: "#111113", border: "1px solid rgba(255,255,255,0.1)", color: "#fff" } }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
